export { default } from './RetailersList';
export { default as adapter } from './adapter';
